import React from "react";
import "./Program_takeway.css";
import Common_title from "../../common_components/Common_title/Common_title";

const Program_takeway = () => {
  const programdata = [
    {
      icon: "/assets/images/home/program-takeway/join.png",
      title: "Join a 100,000+",
      description: "Strong Alumni Network",
    },
    {
      icon: "/assets/images/home/program-takeway/choose.png",
      title: "Choose",
      description: "From a Range of Specializations",
    },
    {
      icon: "/assets/images/home/program-takeway/support.png",
      title: "24/7 Career Support",
      description: "For Ongoing Growth",
    },
    {
      icon: "/assets/images/home/program-takeway/curriculam.png",
      title: "Curriculum Tailored",
      description: "To Your Career Goals",
    },
    {
      icon: "/assets/images/home/program-takeway/flexible.png",
      title: "Flexible",
      description: "No-Cost EMI Options Available",
    },
  ];

  return (
    <>
      <section className="Program_takeway_sec">
        <div className="container">
          <div className="row">
            <div className="col-md-6 pe-md-0">
              <div className="sec1">
                <Common_title
                  className="text-left"
                  title="Program Takeaways"
                  subtitle="A program designed to help you learn, grow, and thrive in any field."
                />

                <div className="allprograms">
                  <p className="tetxt">
                    Curriculum Aligned with Industry Needs
                  </p>
                  <p className="tetxt">Guaranteed Placement Support</p>
                  <p className="tetxt">
                    Same Credibility as On-Campus Programs
                  </p>
                  <p className="tetxt">
                    Interactive Learning with Expert Instructors
                  </p>
                  <p className="tetxt">
                    Build Career-Long Connections with Professionals
                  </p>
                  <p className="tetxt">
                    Flexible Access: 24/7 Live & Recorded Sessions
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-6 ps-md-0 my-auto">
              <div className="sec2">
                {programdata.map((data, index) => (
                  <div className="program_box">
                    <div className="icon_div">
                      <img className="img" src={data.icon} />
                    </div>
                    <div className="text-div">
                      <h5 className="title">{data.title}</h5>
                      <p className="description">{data.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Program_takeway;
